import React from 'react';
import { MapPin, Globe } from 'lucide-react';
export function TenantProfile() {
  const locations = ['Bondi Beach', 'Paddington', 'Fitzroy', 'Pacific Fair', 'Balmain', 'Pitt Street', 'Highpoint', 'Indooroopilly', 'Byron Bay', 'Brighton', 'Malvern', 'Toowoomba', 'Manly', 'Camberwell', 'South Yarra', 'Fremantle', 'Mosman', 'Chadstone', 'Burleigh Heads', '', 'Newton', 'Doncaster', 'Fortitude Valley', ''];
  return <section className="w-full bg-white py-24 px-6" data-id="element-114">
      <div className="max-w-7xl mx-auto" data-id="element-115">
        <div className="flex flex-col lg:flex-row gap-16" data-id="element-116">
          {/* Left Column: Text Content */}
          <div className="w-full lg:w-1/2" data-id="element-117">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-12 tracking-tight" data-id="element-118">
              Tenant Profile
            </h2>

            <div className="flex items-center gap-4 mb-10" data-id="element-119">
              <div className="flex items-center justify-center w-16 h-16 rounded-full bg-[#1A1A1A] text-white font-bold text-xl tracking-tighter" data-id="element-120">
                BN
              </div>
              <div data-id="element-121">
                <h3 className="text-3xl font-light text-[#1A1A1A] tracking-tight" data-id="element-122">
                  Bailey Nelson
                </h3>
                <p className="text-[#1A1A1A]/60 text-sm uppercase tracking-wider font-bold" data-id="element-123">
                  Global Optical Retailer
                </p>
              </div>
            </div>

            <p className="text-lg text-[#1A1A1A]/80 leading-relaxed mb-10 font-light" data-id="element-124">
              Founded in Bondi Beach in 2012, Bailey Nelson has grown into a
              global optical retail powerhouse. With{' '}
              <span className="font-bold text-[#1A1A1A]" data-id="element-125">110 stores</span>{' '}
              across Australia, New Zealand, Canada, and the UK, the brand
              combines fashion-led eyewear with professional optometry services.
            </p>

            <div className="mt-12" data-id="element-126">
              <h3 className="text-xs font-bold uppercase tracking-widest text-[#1A1A1A]/40 mb-6" data-id="element-127">
                Key Australian Locations
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-128">
                {locations.filter(l => l).slice(0, 15).map((loc, i) => <span key={i} className="px-3 py-1 bg-gray-100 text-[#1A1A1A] text-sm rounded-full font-medium" data-id="element-129">
                      {loc}
                    </span>)}
                {locations.filter(l => l).length > 15 && <span className="px-3 py-1 bg-transparent text-[#1A1A1A]/40 text-sm rounded-full font-medium border border-gray-200" data-id="element-130">
                    + {locations.filter(l => l).length - 15} more
                  </span>}
              </div>
            </div>
          </div>

          {/* Right Column: Global Presence Visualization */}
          <div className="w-full lg:w-1/2 bg-[#F5F5F5] rounded-3xl p-8 lg:p-16 flex flex-col items-center justify-center relative overflow-hidden" data-id="element-131">
            {/* Abstract Map Background */}
            <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-132">
              <svg viewBox="0 0 1000 500" className="w-full h-full fill-current text-[#1A1A1A]" data-id="element-133">
                {/* Simplified world map shapes would go here - using placeholder circles for now */}
                <circle cx="200" cy="150" r="40" data-id="element-134" /> {/* North America */}
                <circle cx="500" cy="150" r="30" data-id="element-135" /> {/* Europe */}
                <circle cx="850" cy="350" r="50" data-id="element-136" /> {/* Australia/NZ */}
              </svg>
            </div>

            <div className="relative z-10 text-center" data-id="element-137">
              <Globe className="w-16 h-16 text-[#87C4D8] mx-auto mb-6" data-id="element-138" />
              <h3 className="text-5xl font-black text-[#1A1A1A] mb-2" data-id="element-139">110</h3>
              <p className="text-xl font-medium text-gray-500 uppercase tracking-widest mb-8" data-id="element-140">
                Stores Globally
              </p>

              <div className="flex flex-wrap justify-center gap-3" data-id="element-141">
                {['Australia', 'New Zealand', 'United Kingdom', 'Canada', 'America'].map(country => <span key={country} className="px-4 py-2 bg-white shadow-sm border border-gray-100 rounded-full text-sm font-medium text-[#1A1A1A]" data-id="element-142">
                    {country}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}